import { render, staticRenderFns } from "./DriverContractForReportWidget.vue?vue&type=template&id=5a28e847&scoped=true&"
import script from "./DriverContractForReportWidget.vue?vue&type=script&lang=js&"
export * from "./DriverContractForReportWidget.vue?vue&type=script&lang=js&"
import style0 from "./DriverContractForReportWidget.vue?vue&type=style&index=0&id=5a28e847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28e847",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a28e847')) {
      api.createRecord('5a28e847', component.options)
    } else {
      api.reload('5a28e847', component.options)
    }
    module.hot.accept("./DriverContractForReportWidget.vue?vue&type=template&id=5a28e847&scoped=true&", function () {
      api.rerender('5a28e847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverContractForReportWidget.vue"
export default component.exports